import "../../../assets/scss/credit-balance-style.scss";
import {useEffect, useState} from "react";

import {getUserBalance} from "../../server/User";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {updateCredit} from "../../features/user/userSlice";
import {DepositBalanceBtn} from "../DepositBalanceBtn";
import {useConversionRate} from "../../hooks/useConversionRate";

import {useAuth} from "../../utility/AuthContext";

export const BalanceCredit = () => {
  const { isLoggedIn } = useAuth();
  const [credits, setCredits] = useState<number>(0);
  const credit = useAppSelector((state: any) => state.user.credit);
  const isProvider = useAppSelector((state: any) => state.user.is_provider);
  const { checkConversionRate } = useConversionRate();

  const dispatch = useAppDispatch();

  const initBalance = () => {
    getUserBalance()
      .then((res) => {
        const balance = res.data.data.balance;
        const formattedBalance = (Math.round(balance * 100) / 100).toFixed(2);
        setCredits(+formattedBalance);
        dispatch(updateCredit(balance));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (isLoggedIn) {
      initBalance();
      checkConversionRate(); // only fetches if outdated or empty
    }
  }, [isLoggedIn, credit]);

  return (
    <>
      {isLoggedIn && (
        <div className="credit-wrapper">
          <div className="credit-digit-wrapper">
            <span className="credit-unit">$ {credits}</span>
          </div>
          <DepositBalanceBtn />
        </div>
      )}
    </>
  );
};
